import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BraintreeService } from '../../checkout/braintree.service';
import * as dropin from 'braintree-web-drop-in';

@Component({
  selector: 'pv-braintree-form',
  templateUrl: './braintree-form.component.html',
  styleUrls: ['./braintree-form.component.scss']
})
export class BraintreeFormComponent implements OnInit {
  @Input() formGroup: FormGroup
  @Input() saveTokenOnly: boolean = false;
  @Output() onPayload: EventEmitter<string> = new EventEmitter<string>();
  braintreeInstance;
  requestable;
  clientToken;
  amount;

  constructor(
    private braintreeService: BraintreeService,
  ) { }

  ngOnInit(): void {
    this.braintreeService.getClientToken()
    .subscribe(
      // Use client token which will save customers' payment methods
      ({ clientToken }) => {
        this.clientToken = clientToken
        this.initializeDropIn(clientToken)
      },
      err => console.warn(err)
    )
  }

  ngOnDestroy(): void {
    if (this.braintreeInstance) {
      this.braintreeInstance.teardown()
    }
  }

  async processPayment() {
    if (this.braintreeInstance.isPaymentMethodRequestable()) {
      try {
        const payload = await this.braintreeInstance.requestPaymentMethod()
        this.onPayload.emit(payload)

        if (this.formGroup) {
          this.formGroup.get('nonce').patchValue(payload.nonce);
        }
      } catch (e) {
        console.warn('requestPaymentMethod error', e)
        if (this.braintreeInstance.isPaymentMethodRequestable()) {
          console.warn('clearing payment method')
          await this.braintreeInstance.clearSelectedPaymentMethod()
        }
        this.braintreeService.reportError(e)
        .subscribe(x => console.log(x))
      }
    }
  }

  async initializeDropIn(clientToken: string) {
    // Initialize the braintree instance
    this.braintreeInstance = await dropin.create({
      authorization: clientToken,
      container: '#dropin-container',
      card: {},
      dataCollector: { paypal: true },
      paypal: { flow: 'vault' },
      vaultManager: true
    })

    // When valid credit card is entered
    this.braintreeInstance.on('paymentMethodRequestable', () => this.requestable = true)

    // When credit card is removed
    this.braintreeInstance.on('noPaymentMethodRequestable', () => {
        // this.onNonce.emit()
        this.requestable = false;
      }
    )
  }
}
